<template>
  <v-app class="layout-custom">
    <header-nav />
    <v-main>
      <v-container fluid>
        <router-view />
        <v-spacer class="mb-12" />
      </v-container>
    </v-main>
    <snackbar />
    <loading />
    <footer-nav />
  </v-app>
</template>

<script>

import Loading from '../components/Loading'
import Snackbar from '../components/Snackbar'
import HeaderNav from './components/HeaderNav'
import FooterNav from './components/FooterNav'
export default {
  name: 'AdminApp',
  components: {
    Loading,
    Snackbar,
    HeaderNav,
    FooterNav,
  },
  mixins: [
  ],
  data () {
    return {
      auth : true,
    }
  },
  computed: {
  },
  mounted() {
    /** @typedef document */
    document.title = 'DXE Station Admin'
  },
  head: {
    meta: [
      { name: 'referrer', content: 'no-referrer-when-downgrade' },
    ],
  },
}
</script>
<style lang="scss">
.v-text-field__slot input {
  line-height: 0 !important;
}
</style>
